import { getIsDarkTheme } from 'owa-fabric-theme';
import { isFeatureEnabled } from 'owa-feature-flags';

export default function isComposeDarkModeEnabled() {
    return isFeatureEnabled('cmp-darkMode') && getIsDarkTheme();
}
